/**
 * Deep clone plain serializable data. Prefer global structuredClone (typed via globalThis so TS accepts older lib setups).
 */
export function deepCloneSerializable<T>(value: T): T {
    const g = globalThis as typeof globalThis & {
        structuredClone?: <X>(input: X) => X;
    };
    if (typeof g.structuredClone === 'function') {
        try {
            return g.structuredClone(value);
        } catch {
            /* structuredClone may reject proxies — fall back */
        }
    }
    return JSON.parse(JSON.stringify(value)) as T;
}
